import {
  broadcastToParent,
  RegisteredEventName
} from '@finanzcheck/catalyst-pollard'
import { getCookie, COOKIE_KEY_FCID } from 'utils/cookie'
import { getOptimizelyTrackingAttribute } from 'utils/tracking'
import { AmplitudeEvent } from 'utils/tracking/amplitude/amplitude.interface'
import { Data } from 'interfaces/ApolloResponse.interface'
import {
  HIGH_VOUCHER_LOAN_AMOUNT,
  VAR_B_SMAVA_LOAN_THRESHOLD_HIGH,
  VAR_B_SMAVA_LOAN_THRESHOLD_MEDIUM
} from './voucherAmount'

export const trackVoucherActivation = (
  data: Data,
  campaignId: string
): void => {
  broadcastToParent({
    eventName: RegisteredEventName.tracking,
    data: {
      event: AmplitudeEvent.AddToVoucherCampaign,
      voucherCampaignId: campaignId,
      fcId: getCookie(COOKIE_KEY_FCID),
      context: {
        Optimizely: { userId: getCookie(COOKIE_KEY_FCID) },
        ...getOptimizelyTrackingAttribute(data)
      }
    }
  })
}

export const trackVoucherAmountTier = (data: Data, amount: number): void => {
  const event =
    amount < HIGH_VOUCHER_LOAN_AMOUNT
      ? AmplitudeEvent.RequestedAmountBetween20k50k
      : AmplitudeEvent.RequestedAmountOver50k

  broadcastToParent({
    eventName: RegisteredEventName.tracking,
    data: {
      event,
      context: {
        Optimizely: { userId: getCookie(COOKIE_KEY_FCID) },
        ...getOptimizelyTrackingAttribute(data)
      }
    }
  })

  if (amount >= HIGH_VOUCHER_LOAN_AMOUNT) return

  // <=30k is unreachable under the Var B experiment (no voucher shown), so no
  // detailed event is tracked for that range.
  if (amount <= VAR_B_SMAVA_LOAN_THRESHOLD_MEDIUM) return

  const detailedEvent =
    amount < VAR_B_SMAVA_LOAN_THRESHOLD_HIGH
      ? AmplitudeEvent.RequestedAmountBetween30k40k
      : AmplitudeEvent.RequestedAmountBetween40k50k

  broadcastToParent({
    eventName: RegisteredEventName.tracking,
    data: {
      event: detailedEvent,
      context: {
        Optimizely: { userId: getCookie(COOKIE_KEY_FCID) },
        ...getOptimizelyTrackingAttribute(data)
      }
    }
  })
}
